<script setup lang="ts">

interface Props {
  id?: string
  name?: string
  value: string | number | null
  placeholder?: string
  disabled?: boolean
  errorMessage?: string
  width?: string
  rows?: number
}

const props = withDefaults(defineProps<Props>(), {
  id: '',
  name: '',
  errorMessage: '',
  placeholder: '',
  disabled: false,
  width: '',
  rows: 3,
})

const hasError = computed<boolean>(() => {
  return props.errorMessage !== undefined && props.errorMessage.length > 0
})

const hasFocus = ref(false)

const emit = defineEmits<{
  (e: 'change', val: string): void
  (e: 'enter', val: string): void
  (e: 'focus'): void
}>()
const handleChange = (event: Event) => {
  emit('change', (event.target as HTMLInputElement).value)
}
const handleEnter = (event: Event) => {
  emit('enter', (event.target as HTMLInputElement).value)
}
const handleFocus = () => {
  hasFocus.value = true
  emit('focus')
}

</script>

<template>
  <div
    class="input-group prevent_unselection"
  >
    <div
      v-if="$slots['left']"
      class="form-control w-fit-content d-flex align-items-center form-control--first"
    >
      <slot name="left" />
    </div>
    <textarea
      :style="{ 'max-width': width }"
      :id="id"
      :name="name"
      :value="<string>value"
      :rows="rows"
      :placeholder="placeholder"
      :disabled="disabled"
      :class="{ 'is-invalid': hasError }"
      @focus="handleFocus"
      @blur="hasFocus = false"
      @change="handleChange"
      @input="handleChange"
      @keyup.enter="handleEnter"
      class="form-control"
    />
    <div
      v-if="hasError"
      id="id"
      class="invalid-feedback"
    >
      {{ errorMessage }}
    </div>
    <div
      v-if="$slots['right']"
      class="form-control w-fit-content d-flex align-items-center form-control--last btn-icon"
    >
      <slot name="right" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.w-fit-content {
  max-width: fit-content;
}

.form-control {
  &--first {
    border-right: none !important;
  }
  
  &--last {
    margin-left: 0 !important;
    border-left: none !important;
  }
}
</style>
